module.exports = __webpack_public_path__ + "media/images/download-pdf-da62a2abdaa209f2d35d18a933e0774e.png";